export default __webpack_public_path__ + "static/media/notification_important.f37a1fbf.svg";